<template>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" aria-label="Close" @click="close()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div v-if="loadingDetails" class="product-details-loader">
                <span class="fa fa-spin fa-spinner" />
            </div>
            <div class="modal-body text-white">
                <div class="p-x p-y">
                    <div class="col-xs-12 col-md-6 m-b">
                        <div class="product-detail-gallery">
                            <div
                                v-for="(image, index) in product.images"
                                :key="`img-${index}`"
                                class="product-img"
                            >
                                <img :src="image.image_url" class="img-response-w" :alt="`img-${index}`">
                            </div>
                        </div>
                        <div class="gallery-nav">
                            <div
                                v-for="(image, index) in product.images"
                                :key="`img-${index}`"
                                class="product-img"
                            >
                                <img :src="image.image_url" class="img-response-w" :alt="`img-${index}`">
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <div class="product-name-type m-b">
                            <div class="product-thumb">
                                <img :src="product.main_image" class="img-response-w" alt="thumb">
                            </div>
                            <div class="product-name">
                                <h3 class="text-bold">
                                    {{ product.name }}
                                    <template v-if="partDetails.partName == 'ram'">
                                        <small>(max speed)</small>
                                    </template>
                                </h3>
                            </div>
                            <p class="text-white m-t">
                                {{ product.description }}
                            </p>
                        </div>
                        <div class="product-detail-spects text-white">
                            <ul>
                                <li v-for="(spec, key) in product.specs" :key="key" class="product-spect-content">
                                    <div class="spect-title">
                                        <!-- <p class="text-bold">Name:</p> -->
                                        <p class="text-bold">{{ key }}</p>
                                    </div>
                                    <div v-if="typeof spec == 'string'" class="spect-detail">
                                        <p>
                                            <span v-html="spec" />
                                            <a
                                                v-if="key == 'Maximum Speed'"
                                                href="https://support.nzxt.com/hc/en-us/articles/360038630493-RAM-XMP-Guide-FAQ"
                                                target="_blank"
                                            >
                                                More Info
                                            </a>
                                        </p>
                                    </div>
                                    <div v-else class="spect-detail">
                                        <p v-for="(subspec, index) in spec" :key="index">{{ subspec }} x {{ index }}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="clearfix" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { hasOverflow } from "@u/helpers";

export default {
    props: {
        id: {
            type: [String, Number],
            required: true
        },
        variantId: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            loadingDetails: true,
            product: {
                name: '',
                main_image: '',
                specs: {},
            }
        };
    },
    computed: {
        ...mapState({
            partDetails: state => state.Step4.partDetails
        })
    },
    mounted() {
        this.getProductDetails();
        $('#parts-details-modal').on('hide.bs.modal', () => {
            this.$store.dispatch("changePartDetails", {
                show: false
            });
        });
    },
    methods: {
        getProductDetails() {
            axios.get(`/products/${this.id}/variants/${this.variantId}?relationships=images&merge=true`).then(response => {
                this.product.name = response.data.name;
                this.product.main_image = response.data.main_image;
                this.product.specs = response.data.specs;
                this.product.images = response.data.images;
                this.product.description = response.data.description;

                this.$nextTick(() => {
                    const productSpecs = document.querySelector(".product-detail-spects");
                    if (hasOverflow(productSpecs)) {
                        $(productSpecs).css("overflow-y", "scroll");
                    }
                });

                if (this.partDetails.partName == "ram") {
                    this.product.name = this.partDetails.name;
                    this.product.specs.Capacity = this.partDetails.capacity;
                }

                this.initializeGallery();
            }).catch((error) => {
                toastr.error(error.response.data.status.message);
            }).then(() => {
                this.loadingDetails = false;
            });
        },
        initializeGallery() {
            setTimeout(() => {
                $(".product-detail-gallery").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow:
                        '<button class="slick-prev"><i class="fa fa-angle-left text-green" aria-hidden="true"></i></button>',
                    nextArrow:
                        '<button class="slick-next"><i class="fa fa-angle-right text-green" aria-hidden="true"></i></button>',
                    infinite: false,
                    speed: 300,
                    asNavFor: ".gallery-nav"
                });
                $(".gallery-nav").slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    asNavFor: ".product-detail-gallery",
                    arrows: false,
                    infinite: false,
                    dots: false,
                    focusOnSelect: true,
                });
            }, 200);
        },
        close() {
            $('#parts-details-modal').modal('hide');
        }
    }
};
</script>

<style lang="scss">
#parts-details-modal {
    @media (min-width: 767px) and (max-width: 1200px) {
        button.slick-prev.slick-arrow,
        button.slick-next.slick-arrow {
            height: 30px;
        }

        .slick-next {
            right: -23px !important;
        }

        .col-xs-12.col-md-6.m-b {
            padding-right: 21px;
        }
    }

    .product-name {
        small {
            color: white;
        }
    }
}
</style>

<style scoped>
.modal-header {
    position: relative;
    z-index: 2;
}

.product-details-loader {
    color: white;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    background-color: #000000;
    z-index: 1;
    text-align: center;
    top: 0;
}

.product-thumb {
    width: 20%;
}

.product-name {
    width: 80%;
    padding-left: 15px;
}
</style>
